import { Record } from 'immutable';

const StaySummaryRecord = Record({
  totalNights: 0,
  totalRevenue: 0
});

export class StaySummary extends StaySummaryRecord {
  totalNights: number;
  totalRevenue: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/stay-summary.ts